import { render } from "./Channel.vue?vue&type=template&id=049c9221&scoped=true&ts=true"
import script from "./Channel.vue?vue&type=script&lang=ts"
export * from "./Channel.vue?vue&type=script&lang=ts"

import "./Channel.vue?vue&type=style&index=0&id=049c9221&lang=scss&scoped=true"
import "./Channel.vue?vue&type=style&index=1&id=049c9221&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049c9221"]])

export default __exports__